import { useState } from 'react';

export default function Gallery() {
  const [selectedImage, setSelectedImage] = useState<number | null>(null);

  const projects = [
    {
      title: 'Nueva Instalación',
      category: 'Fontanería Completa',
      image: 'https://storage.googleapis.com/proimagesingapur/offered-service/87-fontaneros/hogami-nueva-instalacion-fontaneria-430x282.webp'
    },
    {
      title: 'Sistema de Ósmosis',
      category: 'Recambios y Mantenimiento',
      image: 'https://storage.googleapis.com/proimagesingapur/offered-service/357-sustituir-recambios-equipo-osmosis-inversa/banner-hogami-recambios-osmosis-430x282-01.webp'
    },
    {
      title: 'Instalación Profesional',
      category: 'Trabajo Especializado',
      image: 'https://de.cdn-website.com/80a82b341676452088cb82f88914b7a9/dms3rep/multi/fondo.jpg'
    },
    {
      title: 'Detección de Fugas',
      category: 'Servicios Especializados',
      image: 'https://grupomartinlorenzo.org/wp-content/uploads/2021/09/localizacion-deteccion-fugas-agua-piscinas-calefaccion-riego.jpg'
    },
    {
      title: 'Instalación en Paredes',
      category: 'Tuberías Ocultas',
      image: 'https://thumbs.dreamstime.com/b/instalando-y-escondiendo-en-las-paredes-tuber%C3%ADas-de-agua-el-ba%C3%B1o-la-casa-corte-ranura-o-trinchera-para-foto-162367698.jpg'
    },
    {
      title: 'Trabajo Vertical',
      category: 'Servicios Especializados',
      image: 'https://www.serviciosverticalescarmona.com/wp-content/uploads/2022/09/WhatsApp-Image-2022-09-26-at-17.27.40-e1664207268123.jpeg'
    },
    {
      title: 'Instalación Completa',
      category: 'Fontanería Residencial',
      image: 'https://font-repar.es/wp-content/uploads/2025/05/IMG_20250708_125200-scaled.jpg'
    },
    {
      title: 'Servicio Profesional',
      category: 'Reparación y Mantenimiento',
      image: 'https://www.sirponsa.es/wp-content/uploads/2024/01/sirponsa-fontaneria.jpg'
    },
    {
      title: 'Trabajo Especializado',
      category: 'Instalaciones',
      image: 'https://manitasxhoras.com/wp-content/uploads/2021/08/fon_05.jpg'
    }
  ];

  const openLightbox = (index: number) => {
    setSelectedImage(index);
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    setSelectedImage(null);
    document.body.style.overflow = 'auto';
  };

  const nextImage = () => {
    if (selectedImage !== null) {
      setSelectedImage((selectedImage + 1) % projects.length);
    }
  };

  const prevImage = () => {
    if (selectedImage !== null) {
      setSelectedImage((selectedImage - 1 + projects.length) % projects.length);
    }
  };

  return (
    <>
      <section id="galeria" className="py-16 sm:py-20 lg:py-24 bg-gradient-to-br from-[#EFF6FF] to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          {/* Header */}
          <div className="text-center mb-12 sm:mb-16">
            <div className="inline-block px-4 sm:px-6 py-2 border-2 border-[#3B82F6] rounded-full mb-4 sm:mb-6">
              <span className="text-[#3B82F6] text-xs sm:text-sm font-semibold">Galería</span>
            </div>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-[#1e3a8a] mb-4 sm:mb-6 px-4">
              Nuestros Proyectos
              <span className="block text-[#3B82F6] mt-2">Realizados</span>
            </h2>
            <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto px-4">
              Cada proyecto es una muestra de nuestro compromiso con la calidad y la satisfacción del cliente.
            </p>
          </div>

          {/* Gallery Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
            {projects.map((project, index) => (
              <div
                key={index}
                onClick={() => openLightbox(index)}
                className="group relative overflow-hidden rounded-xl sm:rounded-2xl shadow-lg hover:shadow-2xl transition-all cursor-pointer"
              >
                <div className="aspect-square overflow-hidden">
                  <img
                    src={project.image}
                    alt={project.title}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-0 left-0 right-0 p-4 sm:p-6 text-white">
                    <p className="text-xs sm:text-sm font-semibold mb-1 sm:mb-2 text-[#FFD700]">{project.category}</p>
                    <h3 className="text-base sm:text-lg lg:text-xl font-bold">{project.title}</h3>
                  </div>
                  <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                    <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center">
                      <div className="w-6 h-6 sm:w-8 sm:h-8 flex items-center justify-center">
                        <i className="ri-search-line text-white text-xl sm:text-2xl"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox */}
      {selectedImage !== null && (
        <div
          className="fixed inset-0 z-[100] bg-black/95 flex items-center justify-center p-4"
          onClick={closeLightbox}
        >
          {/* Close Button */}
          <button
            onClick={closeLightbox}
            className="absolute top-4 right-4 sm:top-6 sm:right-6 w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-white/10 backdrop-blur-sm hover:bg-white/20 flex items-center justify-center transition-all cursor-pointer z-10"
          >
            <div className="w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center">
              <i className="ri-close-line text-white text-xl sm:text-2xl"></i>
            </div>
          </button>

          {/* Previous Button */}
          <button
            onClick={(e) => {
              e.stopPropagation();
              prevImage();
            }}
            className="absolute left-4 sm:left-6 w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-white/10 backdrop-blur-sm hover:bg-white/20 flex items-center justify-center transition-all cursor-pointer"
          >
            <div className="w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center">
              <i className="ri-arrow-left-s-line text-white text-xl sm:text-2xl"></i>
            </div>
          </button>

          {/* Next Button */}
          <button
            onClick={(e) => {
              e.stopPropagation();
              nextImage();
            }}
            className="absolute right-4 sm:right-6 w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-white/10 backdrop-blur-sm hover:bg-white/20 flex items-center justify-center transition-all cursor-pointer"
          >
            <div className="w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center">
              <i className="ri-arrow-right-s-line text-white text-xl sm:text-2xl"></i>
            </div>
          </button>

          {/* Image Container */}
          <div
            className="max-w-6xl max-h-[90vh] mx-auto px-4 sm:px-6"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={projects[selectedImage].image}
              alt={projects[selectedImage].title}
              className="w-full h-full object-contain rounded-xl sm:rounded-2xl"
            />
            <div className="text-center mt-4 sm:mt-6">
              <p className="text-[#FFD700] text-xs sm:text-sm font-semibold mb-1 sm:mb-2">
                {projects[selectedImage].category}
              </p>
              <h3 className="text-white text-lg sm:text-xl lg:text-2xl font-bold">
                {projects[selectedImage].title}
              </h3>
              <p className="text-white/60 text-xs sm:text-sm mt-1 sm:mt-2">
                {selectedImage + 1} / {projects.length}
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
